module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/iconfont/MaterialIcons-Regular.ttf
// module id = ../../../../../src/fonts/iconfont/MaterialIcons-Regular.ttf
// module chunks = 3